import PrecallSurvey from '@components/pages/account/survey/PrecallSurvey';
import { AEP_SurveyStep } from '@components/pages/account/survey/PrecallSurvey/constants';

export const PrecallAepLanding = () => <PrecallSurvey step={AEP_SurveyStep.AEP_LANDING} />;

export default PrecallAepLanding;
